module.exports = __webpack_public_path__ + "64d6d83df5af4ce4844bb3ce241383c3.png";


//////////////////
// WEBPACK FOOTER
// ./content/mupit/1t15.png
// module id = 1330
// module chunks = 0